export default __webpack_public_path__ + "static/media/Kubernaties.0e4a8830.svg";